<div class="organizer-payouts-table">
  @if (payouts().length === 0) {
    <p class="organizer-payouts-table__empty">No payout requests found.</p>
  } @else {
    <table
      mat-table
      [dataSource]="payouts()"
      class="organizer-payouts-table__table"
    >
      <!-- Amount Column -->
      <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef>Amount</th>
        <td mat-cell *matCellDef="let payout">
          {{ payout.amount | currency }}
        </td>
      </ng-container>

      <!-- Status Column -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let payout">
          <mat-chip
            highlighted
            [class]="
              'organizer-payouts-table__status-chip organizer-payouts-table__status-chip--' +
              payout.status
            "
          >
            {{ getStatusLabel(payout.status) }}
          </mat-chip>
        </td>
      </ng-container>

      <!-- Created At Column -->
      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef>Requested</th>
        <td mat-cell *matCellDef="let payout">
          {{ payout.createdAt | date: "short" }}
        </td>
      </ng-container>

      <!-- Updated At Column -->
      <ng-container matColumnDef="updatedAt">
        <th mat-header-cell *matHeaderCellDef>Last Updated</th>
        <td mat-cell *matCellDef="let payout">
          {{ payout.updatedAt | date: "short" }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  }
</div>
